import PropTypes from 'prop-types';
import React from 'react';
import { FileSelector } from '@carvana/purchase-helpers';
import { CarvanaButton } from '@carvana/purchase-styles';
import * as sc from './verification-document.styles';

const VerificationDocumentV2 = props => {
  const {
    fileSelector,
    title,
    subtitle,
    status,
    showUpload,
    showEdit,
    showView,
    wholeDocClick,
    buttonText,
    isLoading,
    isPointerDisabled,
    leftChildren,
    greyOutSecondary,
    uploadFunction,
    editFunction,
    viewFunction
  } = props;
  const isGreyedOut =
    !showUpload && status?.toLowerCase() !== 'complete' && greyOutSecondary;

  const UploadButton = fileSelector.enabled ? FileSelector : CarvanaButton;

  return (
    <sc.TypeWrapper
      style={{ cursor: isPointerDisabled ? 'default' : 'pointer' }}
      onClick={wholeDocClick}
    >
      <sc.ContentWrapper>
        <sc.LeftContent {...props}>
          <sc.TypeContent>
            <sc.TitleBadgeWrapper>
              <sc.TypeTitle isGreyedOut={isGreyedOut}>{title}</sc.TypeTitle>
              {status?.toLowerCase() == 'complete' && <sc.UploadedBadge>Uploaded</sc.UploadedBadge>}
            </sc.TitleBadgeWrapper>
            <sc.TypeSubtitle>{subtitle}</sc.TypeSubtitle>
            {leftChildren}
          </sc.TypeContent>
        </sc.LeftContent>
        <sc.RightContent isStaticHeight={subtitle == null}>
          {showUpload && (
            <UploadButton
              buttonStyles={sc.buttonStyles}
              ghost
              handleSelectedFile={fileSelector.handleSelectedFile}
              onClick={uploadFunction}
              uppercase
              isLoading={isLoading}
              {...props}
            >
              {buttonText || 'Upload'}
            </UploadButton>
          )}

          {showEdit && (
            <sc.RightContentItem onClick={editFunction}>
              {buttonText || 'Edit'}
            </sc.RightContentItem>
          )}

          {showView && (
            <sc.RightContentItem onClick={viewFunction}>
              {buttonText || 'View'}
            </sc.RightContentItem>
          )}
        </sc.RightContent>
      </sc.ContentWrapper>
    </sc.TypeWrapper>
  );
};

VerificationDocumentV2.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  status: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  showUpload: PropTypes.bool,
  fileSelector: PropTypes.shape({
    enabled: PropTypes.bool,
    handleSelectedFile: PropTypes.func
  }),
  showEdit: PropTypes.bool,
  showView: PropTypes.bool,
  uploadFunction: PropTypes.func,
  editFunction: PropTypes.func,
  viewFunction: PropTypes.func,
  wholeDocClick: PropTypes.func,
  buttonText: PropTypes.string,
  isLoading: PropTypes.bool,
  isPointerDisabled: PropTypes.bool,
  leftChildren: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType])
};

VerificationDocumentV2.defaultProps = {
  buttonText: null,
  documentId: null,
  fileSelector: {
    enabled: false,
    handleSelectedFile: null
  },
  subtitle: null,
  status: null,
  showUpload: false,
  showEdit: false,
  showView: false,
  isLoading: false,
  isPointerDisabled: false,
  leftChildren: null,
  uploadFunction: () => {},
  editFunction: () => {},
  viewFunction: () => {},
  wholeDocClick: () => {}
};

export default VerificationDocumentV2;
